/* ═══════════════════════════════════════════════
   TruSmile — Carrusel de videos (9:16)
   assets/trusmile-video-carousel.js
   Autoplay solo de los visibles · muteado · loop · tap para sonido.
   ═══════════════════════════════════════════════ */
 
(function () {
  'use strict';
 
  function initCarousel(root) {
    const track = root.querySelector('[data-tvc-track]');
    if (!track) return;
 
    const slides = Array.prototype.slice.call(root.querySelectorAll('[data-tvc-slide]'));
    const prev = root.querySelector('[data-tvc-prev]');
    const next = root.querySelector('[data-tvc-next]');
 
    /* ── autoplay solo de lo visible ── */
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduceMotion) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target.querySelector('[data-tvc-video]');
          if (!video) return;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            const p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: [0, 0.5, 1], root: track });
      slides.forEach(function (s) { io.observe(s); });
    } else {
      // fallback: intentar reproducir todos (muteados)
      slides.forEach(function (s) {
        const v = s.querySelector('[data-tvc-video]');
        if (v) { const p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
 
    /* ── sonido on/off por video (uno a la vez) ── */
    root.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-tvc-sound]');
      if (!btn) return;
      const slide = btn.closest('[data-tvc-slide]');
      const video = slide && slide.querySelector('[data-tvc-video]');
      if (!video) return;
 
      const willUnmute = video.muted;
      // silenciar todos los demás
      slides.forEach(function (s) {
        const v = s.querySelector('[data-tvc-video]');
        if (v && v !== video) { v.muted = true; s.classList.remove('is-unmuted'); }
      });
      video.muted = !willUnmute;
      slide.classList.toggle('is-unmuted', willUnmute);
      if (willUnmute) {
        const p = video.play();
        if (p && p.catch) p.catch(function () {});
        btn.setAttribute('aria-label', 'Silenciar');
      } else {
        btn.setAttribute('aria-label', 'Activar sonido');
      }
    });
 
    /* ── flechas ── */
    function step() {
      const slide = slides[0];
      const w = slide ? slide.getBoundingClientRect().width : 260;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16') || 16;
      return w + gap;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
 
    function updateArrows() {
      if (!prev || !next) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    }, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }
 
  function boot() {
    document.querySelectorAll('[data-tvc]').forEach(initCarousel);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();